<template>
  <tr-button
    dropdown="true"
    :label="selectedFilter"
    text-variant="body"
    variant="text"
  >
    <tr-dropdown-item
      key="all"
      :on-item-click="search.bind(undefined, undefined, 'Todos os status')"
    >
      Todos os status
    </tr-dropdown-item>
    <tr-dropdown-item
      v-for="(statusName, statusKey) in batchStatusNamePageFilter"
      :key="statusKey"
      :on-item-click="search.bind(undefined, statusKey, statusName)"
    >
      {{ statusName }}
    </tr-dropdown-item>
  </tr-button>
</template>

<script>
import batchStatusNamePageFilter from '@/apps/payments/payments/batch/constants/batchStatusNamePageFilter';

export default {
  name: 'batch-status-dropdown-filter',
  props: {
    onSearch: {
      required: true,
      type: Function
    }
  },
  data: () => ({
    batchStatusNamePageFilter,
    selectedFilter: 'Todos os status'
  }),
  methods: {
    search(key, name) {
      this.selectedFilter = name;
      this.onSearch(key);
    }
  }
};
</script>
